import { useTranslations } from 'next-intl';

export const ServiceDeskSection = () => {
  const tServiceDesk = useTranslations('inspector.serviceDesk');

  return (
    <div className="flex h-full flex-col gap-y-2 bg-ui-base p-12">
      <div className="text-3xl font-bold">{tServiceDesk('title')}</div>
      <div>{tServiceDesk('description')}</div>
      <div className="mt-8 flex flex-col gap-y-2 text-highlight-base">
        <a className="underline">{tServiceDesk('links.first')}</a>
        <a className="underline">{tServiceDesk('links.second')}</a>
        <a className="underline">{tServiceDesk('links.third')}</a>
        <a className="underline">{tServiceDesk('links.fourth')}</a>
        <a className="underline">{tServiceDesk('links.fifth')}</a>
      </div>
    </div>
  );
};
